<template>
  <div>
    <div class="contents">
      <b-form @submit="onSubmit">
        <div class="row g-0 table-type header-col">
          <div class="col-sm-4">{{ $t("title.common.display") }}</div>
          <div class="col-sm-8">
            <b-form-checkbox
              v-model="form.display_flag"
              name="check-button"
              size="lg"
              switch
            >
            </b-form-checkbox>
          </div>
          <div class="col-sm-4">
            {{ $t("title.common.status") }}
          </div>
          <div class="col-sm-8">
            <select class="form-select-lg" v-model="form.status">
              <option value="1">{{ $t("filter.common.ready") }}</option>
              <option value="2">{{ $t("filter.common.playing") }}</option>
              <option value="3">{{ $t("filter.common.completed") }}</option>
              <option value="4">{{ $t("filter.common.cancel") }}</option>
            </select>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.title") }}
          </div>
          <div class="col-sm-8">
            <input type="text" v-model="form.title" />
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.period") }}
          </div>
          <div class="col-sm-8">
            <div class="row row-cols-1 row-cols-sm-4 g-2 flex-grow-1">
              <div class="col">
                <input
                  type="date"
                  class="form-control-lg"
                  v-model="form.startdate"
                />
              </div>
              <div>
                <select class="w-100" v-model="starttime">
                  <option v-for="(time, idx) in option.starttimes" :key="idx">
                    {{ time }}
                  </option>
                </select>
              </div>
              <div class="col">
                <input
                  type="date"
                  class="form-control-lg"
                  v-model="form.enddate"
                />
              </div>
              <div>
                <select class="w-100" v-model="endtime">
                  <option v-for="(time, idx) in option.endtimes" :key="idx">
                    {{ time }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.tournament.tournament_info") }}
          </div>
          <div class="col-sm-8">
            <textarea
              v-model="form.remark"
              cols="30"
              rows="10"
              :placeholder="$t('text.tournament.tournament_info_placeholder')"
            ></textarea>
          </div>

          <div class="col-sm-4">
            {{ $t("title.tournament.description") }}
          </div>
          <div class="col-sm-8">
            <textarea
              v-model="form.etcprize"
              cols="30"
              rows="10"
              :placeholder="$t('text.tournament.description_placeholder')"
            ></textarea>
          </div>

          <!-- <template v-for="(val, index) in [1, 2]"> -->
          <template v-for="(val, index) in [1]">
            <div class="col-sm-4" :key="'i' + index">
              {{ $t("text.common.tournament_banner") }}
            </div>
            <div class="col-sm-8 d-block" :key="'i_' + index">
              <div class="d-flex flex-column flex-sm-row flex-grow-1">
                <div class="flex-shrink-0 me-0 me-sm-2 mb-2 mb-sm-0">
                  <img
                    :src="
                      tourbinary[index] &&
                      tourbinary[index].filepath_web | get_img
                    "
                    class="avatar avatar-lg rounded-0"
                  />
                </div>
                <div class="flex-grow-1">
                  <b-form-file
                    v-model="file[index]"
                    :ref="file[index]"
                    :state="Boolean(file[index])"
                    :placeholder="$t('text.tournament.select_file_or_drop')"
                    :drop-placeholder="$t('text.tournament.drop_it_here')"
                    @change="fileSelect($event, index)"
                  >
                  </b-form-file>
                </div>
              </div>
              <a
                class="d-block mt-2 text-subscript more"
                href="/img/Tournament.Banner.Guidelines.v1.pdf?v=1.1.6"
                target="_blank"
              >
                <span class="material-icons-outlined">info</span>
                {{ $t("text.common.tournament_banner_guidelines") }}
              </a>
            </div>
          </template>

          <div class="col-sm-4">
            {{ $t("title.tournament.tournament_host_type") }}
          </div>
          <div class="col-sm-8">
            <select v-model="form.regtype" class="form-select-lg" disabled>
              <option value="1">{{ $t("filter.tournament.owner") }}</option>
              <option value="2">
                {{ $t("filter.tournament.worker") }}
              </option>
              <option value="3">
                {{ $t("filter.tournament.player") }}Player
              </option>
              <option value="4">{{ $t("filter.tournament.admin") }}</option>
            </select>
          </div>

          <div class="col-sm-4">
            {{ $t("title.tournament.tournament_game_type") }}
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <select v-model="form.gametype_fk" class="form-select" @change="change_gametype($event)">
                <option value="1">
                  {{ $t("text.common.stroke") }}
                </option>
                <option value="9">
                  {{ $t("text.common.scramble") }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.entry_limit") }}
          </div>
          <div class="col-sm-8 d-block">
            <input
              type="text"
              v-model="form.entrylimit"
              :placeholder="$t('text.tournament.entry_limit_placeholder')"
              class="text-red"
            />
            <p class="mt-2 text-subscript">
              {{ $t("text.common.entry_limit") }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.tournament.tournament_participation_type") }}
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <!-- <select v-model="form.participationtype_fk" class="form-select" @change="change_participation_type($event)"> -->
              <select v-model="form.participationtype_fk" class="form-select">
                <option value="1">
                  {{ $t("text.common.participation") }} {{ $t("text.common.free") }}
                </option>
                <option value="2">
                 {{ $t("text.common.participation") }} {{ $t("text.common.ticket") }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-4">Product ID</div>
          <div class="col-sm-8 d-block">
            <input
              type="text"
              v-model="form.product_id"
              placeholder="prod_xxx..."
              class="text-red"
            />
            <p class="mt-2 text-subscript">
              Please enter the product ID registered in STRIPE
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.tournament") }} {{ $t("title.common.type") }}
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <select v-model="form.tourtype_fk" class="form-select">
                <option value="1">
                  {{ $t("filter.tournament.public") }}
                </option>
                <option value="2" v-if="form.gametype_fk==1">
                  {{ $t("filter.tournament.invitation") }}
                </option>
              </select>
              <button
                v-if="form.tourtype_fk == '2'"
                type="button"
                class="btn btn-primary btn-lg"
                @click="invitational_modal"
              >
                {{ $t("button.tournament.invitation") }}
              </button>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.tournament.tournament_class") }}
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <select v-model="form.tour_class" class="form-select">
                <option value="1">
                  {{ $t("text.admin.regular") }}
                </option>
                <option value="2">
                  {{ $t("text.admin.major") }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.tournament.rank_type") }}
          </div>
          <div class="col-sm-8">
            <div class="input-group">
              <select v-model="form.tour_rank_type" class="form-select">
                <option value="0"  v-if="form.gametype_fk==1">
                  {{ $t("filter.common.total") }}
                </option>
                <option value="1">
                  {{ $t("filter.tournament.low_gross") }}
                </option>
                <option value="2" v-if="form.gametype_fk==1">
                  {{ $t("filter.tournament.low_net") }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.tournament.prize_rank") }}
          </div>
          <div class="col-sm-8 d-block">
            <select
              class="form-select-lg"
              name="rankno"
              v-model="form.rankno"
              @change="input_rankno($event)"
            >
              <template v-for="(rank, index) in rank_count">
                <option :value="rank" :key="index + 'r'">{{ rank }}</option>
              </template>
            </select>
            <p class="mt-2 text-subscript">
              {{ $t("text.common.prize_rank") }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.tournament.prize_goods") }}
          </div>
          <div class="col-sm-8 d-block">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 gx-2 gy-3">
              <template v-for="(rank, index) in form.rankno">
                <div class="col" v-if="form.rankno >= rank" :key="index + 'rp'">
                  <p class="mb-1 fw-500 fs-14 text-black">Top {{ rank }}</p>
                  <input
                    type="text"
                    :name="'rankprize' + rank"
                    v-model="form.rankprizelist.rankprize[index]"
                    class="text-prize"
                  />
                </div>
              </template>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.oom_point") }}
          </div>
          <div class="col-sm-8">
            <b-form-checkbox
              v-model="form.oom_point"
              size="lg"
              name="check-button"
              switch
            >
            </b-form-checkbox>
          </div>
          <div class="col-sm-4">
            {{ $t("title.tournament.condition") }}
          </div>
          <div class="col-sm-8 d-block">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-xxl-4 gx-2 gy-3">
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.tournament.wind") }}
                  {{ $t("title.tournament.setting") }}
                </p>
                <select name="wind" v-model="form.wind" class="form-select-lg">
                  <option value="1">{{ $t("text.common.calm") }}</option>
                  <option value="2">{{ $t("text.common.light") }}</option>
                  <option value="3">
                    {{ $t("text.common.moderate") }}
                  </option>
                  <option value="4">
                    {{ $t("text.common.strong") }}
                  </option>
                  <option value="5">
                    {{ $t("text.common.random") }}
                  </option>
                </select>
              </div>
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.tournament.mulligan") }}
                </p>
                <select
                  name="mulligan"
                  v-model="form.mulligan"
                  class="form-select-lg"
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                </select>
              </div>
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.tournament.teebox_male") }}
                </p>
                <select
                  name="teeboxman"
                  v-model="form.teeboxman"
                  class="form-select-lg"
                >
                  <option value="1">
                    <!-- {{ $t("text.common.pro") }}-->{{
                      $t("text.common.blue")
                    }}
                  </option>
                  <option value="2">
                    <!-- {{ $t("text.common.regular") }} -->
                    {{ $t("text.common.white") }}
                  </option>
                  <option value="3">
                    <!-- {{ $t("text.common.lady") }} -->
                    {{ $t("text.common.red") }}
                  </option>
                  <option value="3">
                    <!-- {{ $t("text.common.senior") }} -->
                    {{ $t("text.common.yellow") }}
                  </option>
                </select>
              </div>
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.tournament.teebox_female") }}
                </p>
                <select
                  name="teeboxwoman"
                  v-model="form.teeboxwoman"
                  class="form-select-lg"
                >
                  <option value="1">
                    <!-- {{ $t("text.common.pro") }} -->
                    {{ $t("text.common.blue") }}
                  </option>
                  <option value="2">
                    <!-- {{ $t("text.common.regular") }} -->
                    {{ $t("text.common.white") }}
                  </option>
                  <option value="3">
                    <!-- {{ $t("text.common.lady") }} -->
                    {{ $t("text.common.red") }}
                  </option>
                  <option value="3">
                    <!-- {{ $t("text.common.senior") }} -->
                    {{ $t("text.common.yellow") }}
                  </option>
                </select>
              </div>
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.common.level") }}
                </p>
                <select class="form-select-lg" v-model="form.level">
                  <option value="1">{{ $t("text.common.pro") }}</option>
                  <option value="2">{{ $t("text.common.semi_pro") }}</option>
                  <option value="3">{{ $t("text.common.advanced") }}</option>
                  <option value="4">{{ $t("text.common.normal") }}</option>
                  <option value="5">{{ $t("text.common.beginner") }}</option>
                </select>
              </div>
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.common.greenspeed") }}
                </p>
                <select class="form-select-lg" v-model="form.greenspeed_fk">
                  <option
                    v-for="n in 5"
                    :key="'greenspeed' + n"
                    :value="String(n)"
                  >
                    {{ $options.filters.greenspeed(String(n)) }}
                  </option>
                </select>
              </div>
              <div class="col">
                <p class="mb-1 fw-500 fs-14">
                  {{ $t("title.common.greengravity") }}
                </p>
                <select class="form-select-lg" v-model="form.greengravity_fk">
                  <option
                    v-for="n in 5"
                    :key="'greengravity' + n"
                    :value="String(n)"
                  >
                    {{ $options.filters.greengravity(String(n)) }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.course") }}
          </div>
          <div class="col-sm-8 d-block">
            <p
              class="mb-2 text-black fw-500"
              v-for="(cc, index) in form.courselist"
              :key="index + 'cc'"
            >
              {{ index > 0 ? ", " : "" }}
              {{ tournamentcoursenamelist[cc] }}
            </p>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="$bvModal.show('modal-select-course')"
            >
              {{ $t("button.tournament.select_golfcourse") }}
            </button>
            <p class="mt-2 text-subscript text-orange">
              {{ $t("text.common.only_one_golfcourse") }}
            </p>
          </div>

          <div class="col-sm-4">
            {{ $t("title.common.subcourse") }}
          </div>
          <div class="col-sm-8 d-block">
            <div
              v-if="courseview_yn === 'y'"
              class="row row-cols-1 row-cols-sm-2 g-2"
            >
              <div
                v-for="(anc, index1) in form.subcourselist"
                :key="index1"
                class="col"
              >
                <p class="mb-1 text-black fw-500">
                  Sub Course {{ anc.subcourseseq }}
                </p>
                <select
                  class="form-select-lg"
                  v-model="form.subcoursetype[index1]"
                  required
                >
                  <template v-if="anc.subcourseseq === '1'">
                    <option value="0">{{ $t("text.common.none") }}</option>
                    <template v-for="(anc_, index1_) in form.subcourselist">
                      <!-- <option
                        :key="index1_"
                        :value="anc_.subcourseseq"
                        v-if="anc_.subcourseseq === '1'"
                      > -->
                      <option :key="index1_" :value="anc_.subcourseseq">
                        {{ anc_.subcoursename }}
                      </option>
                    </template>
                  </template>
                  <template v-if="anc.subcourseseq === '2'">
                    <option value="0">{{ $t("text.common.none") }}</option>
                    <template v-for="(anc_, index1_) in form.subcourselist">
                      <!-- <option
                        :key="index1_"
                        :value="anc_.subcourseseq"
                        v-if="anc_.subcourseseq !== '1'"
                      > -->
                      <option :key="index1_" :value="anc_.subcourseseq">
                        {{ anc_.subcoursename }}
                      </option>
                    </template>
                  </template>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- // table-type -->

        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.common.list')"
            @click="$router.push({ name: 'TournamentList' })"
            >{{ $t("button.common.list") }}</b-button
          >
          <b-button
            size="xl"
            variant="primary"
            type="submit"
            :aria-label="$t('button.common.save')"
            >{{ $t("button.common.save") }}</b-button
          >
        </div>
      </b-form>
    </div>

    <b-modal
      id="modal-select-course"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("title.common.select_golfcourse") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-select-course')"
        ></b-button>
      </template>

      <b-form-checkbox-group
        v-model="form.courselist"
        name="courselist"
        class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 g-3 px-2"
      >
        <div
          class="col form-check pe-sm-3"
          :key="index + 'cl'"
          v-for="(course, index) in tournamentcourselist"
        >
          <b-form-checkbox
            :value="course.maincourseno"
            @change="chk_mc()"
            class="d-flex align-items-start"
          >
            {{ course.coursename }}
          </b-form-checkbox>
        </div>
      </b-form-checkbox-group>

      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-select-course')"
        >
          {{ $t("button.common.close") }}
        </b-button>
        <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.apply')"
          @click="cancel()"
        >
          {{ $t("button.common.apply") }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-add-shop"
      ref="modal-add-shop"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("title.common.edit") }} {{ $t("title.common.location") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['modal-add-shop'].hide()"
        ></b-button>
      </template>
      <div class="container-fluid total_manager">
        <div class="tournament">
          <table class="table board">
            <thead>
              <tr>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.number") }}
                </th>
                <th class="col-auto">{{ $t("title.common.location") }}</th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.owner") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.location") }}
                  {{ $t("title.common.address") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.phone") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.status") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.control") }}
                </th>
                <th class="th-arrow"></th>
              </tr>
            </thead>
            <tbody v-if="data_yn">
              <template v-for="(item, index) in tournamentlocation">
                <tr class="btn1" @click="toggle_tr(index)" :key="index + 'l1'">
                  <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
                  <td class="col-auto">{{ item.shopname }}</td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.name }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.address }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.phone ? item.phone : "none" }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ $t("title.tournament.participant") }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell">
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-xs"
                      @click="admintournamentshopdrop(item.shopno)"
                    >
                      {{ $t("button.common.cancel") }}
                    </button>
                  </td>
                  <td class="td-arrow" @click="toggle_tr(index)">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide === index }"
                    />
                  </td>
                </tr>
                <tr
                  class="col-auto d-lg-none d-md-tabel-cell"
                  :class="{ show: view_hide === index }"
                  :key="index + 'r1'"
                  v-if="view_hide === index"
                >
                  <td class="text-start" colspan="7">
                    <div class="toggle-content">
                      <div class="row">
                        <div class="col-6">{{ $t("title.common.number") }}</div>
                        <div class="col-6">{{ item.no }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">{{ $t("title.common.owner") }}</div>
                        <div class="col-6">{{ item.name }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          {{ $t("title.common.address") }}
                        </div>
                        <div class="col-6">{{ item.address }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">{{ $t("title.common.phone") }}</div>
                        <div class="col-6">
                          {{ item.phone ? item.phone : "-" }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          {{ $t("title.common.control") }}
                        </div>
                        <div class="col-6">
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-xs"
                            @click="admintournamentshopdrop(item.shopno)"
                          >
                            {{ $t("button.common.cancel") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="7">{{ $t("text.common.no_data") }}</td>
              </tr>
            </tbody>
          </table>
          <div class="row regis-btn">
            <div class="col-lg-6 alone">
              <button
                class="btn btn-primary btn-md btn1"
                type="button"
                @click="close_modal"
              >
                {{ $t("button.common.save") }}
              </button>
            </div>
          </div>

          <b-form @submit="onModalSubmit">
            <div class="filter-box-2 mt-5">
              <div>
                <select class="form-select-lg" v-model="searchData.searchtype">
                  <option value="1">{{ $t("filter.common.location") }}</option>
                  <option value="2">{{ $t("filter.common.shop_name") }}</option>
                </select>
              </div>
              <div class="search-input">
                <input
                  type="text"
                  class="form-control-lg"
                  v-model="searchData.searchname"
                />
                <input
                  class="btn btn-primary btn-lg search"
                  type="submit"
                  value=""
                />
              </div>
            </div>
          </b-form>
          <table class="table board">
            <thead>
              <tr>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.number") }}
                </th>
                <th class="col-auto">{{ $t("title.common.location") }}</th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.owner") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.address") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.phone") }}
                </th>
                <th class="col-auto d-none d-lg-table-cell">
                  {{ $t("title.common.control") }}
                </th>
                <th class="th-arrow"></th>
              </tr>
            </thead>
            <tbody v-if="data_yn2">
              <template v-for="(item, index) in items">
                <tr class="btn1" @click="toggle_tr2(index)" :key="index + 'l2'">
                  <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
                  <td class="col-auto">{{ item.shopname }}</td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.name }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.address }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell">
                    {{ item.phone }}
                  </td>
                  <td class="col-auto d-none d-lg-table-cell">
                    <button
                      type="button"
                      class="btn btn-outline-secondary btn-xs"
                      @click="
                        admintournamentshopapply(item.shopno, item.shopname)
                      "
                    >
                      {{ $t("button.common.apply") }}
                    </button>
                  </td>
                  <td class="td-arrow" @click="toggle_tr(index)">
                    <img
                      src="/img/arrow_none_collapsed.png"
                      :class="{ 'btn-toggle-arrow': view_hide2 === index }"
                    />
                  </td>
                </tr>
                <tr
                  class="col-auto d-lg-none d-md-tabel-cell"
                  :class="{ show: view_hide2 === index }"
                  :key="index + 'r2'"
                  v-if="view_hide2 === index"
                >
                  <td class="text-start" colspan="6">
                    <div class="toggle-content">
                      <div class="row">
                        <div class="col-6">{{ $t("title.common.number") }}</div>
                        <div class="col-6">{{ item.no }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">{{ $t("title.common.owner") }}</div>
                        <div class="col-6">{{ item.name }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          {{ $t("title.common.address") }}
                        </div>
                        <div class="col-6">{{ item.address }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">{{ $t("title.common.phone") }}</div>
                        <div class="col-6">{{ item.phone }}</div>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          {{ $t("title.common.control") }}
                        </div>
                        <div class="col-6">
                          <button
                            type="button"
                            class="btn btn-outline-secondary btn-xs"
                            @click="
                              admintournamentshopapply(
                                item.shopno,
                                item.shopname
                              )
                            "
                          >
                            {{ $t("button.common.apply") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6">{{ $t("text.common.no_data") }}</td>
              </tr>
            </tbody>
          </table>
          <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="page_total"
            v-model="searchData.pageno"
            use-router
            :aria-label="$t('text.common.pagination')"
            v-if="page_total > 1"
            first-class="prev"
            prev-class="prev"
            next-class="next"
            last-class="next"
            hide-ellipsis
            limit="10"
          >
            <template #first-text
              ><i class="material-icons"
                >keyboard_double_arrow_left</i
              ></template
            >
            <template #prev-text
              ><i class="material-icons">navigate_before</i></template
            >
            <template #next-text
              ><i class="material-icons">navigate_next</i></template
            >
            <template #last-text
              ><i class="material-icons"
                >keyboard_double_arrow_right</i
              ></template
            >
            <template #page="{ page, active }">
              <a class="page-link" v-if="active">{{ page }}</a>
              <a class="page-link" v-else>{{ page }}</a>
            </template>
          </b-pagination-nav>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-tournament-invitational"
      size="xl"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("title.tournament.invitational") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-tournament-invitational')"
        ></b-button>
      </template>

      <h6 class="modal-subtitle">
        {{ $t("text.common.invitation_list") }}
      </h6>
      <table class="table board table-sm">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">{{ $t("title.common.id") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.email") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.gender") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.favorite_location") }}
            </th>
            <th class="col-auto w-1">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="tour_member_items.length > 0">
          <template v-for="(item, index) in tour_member_items">
            <tr :key="index">
              <td class="col-auto d-none d-lg-table-cell w-1">
                {{ item.playerinfo.no }}
              </td>
              <td class="col-auto text-start text-lg-center">
                {{ item.playerinfo.id }}
              </td>
              <td class="col-auto d-none d-lg-table-cell text-start">
                <MemberInfo
                  :nickname="item.playerinfo.nickname"
                  :playerno="item.playerinfo.playerno"
                  :displayText="item.playerinfo.nickname"
                />
              </td>
              <td class="col-auto d-none d-lg-table-cell text-break text-start">
                {{ item.playerinfo.email }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{
                  item.playerinfo.gender === "M"
                    ? $t("filter.common.male")
                    : $t("filter.common.female")
                }}
              </td>
              <td class="col-auto d-none d-lg-table-cell shop-name">
                <p
                  v-for="(shop, index_s) in item.shoplist"
                  :key="index_s + 's'"
                >
                  {{ shop.shopname }}
                </p>
              </td>
              <td class="col-auto w-1">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-xs"
                  @click="admintournamentplayerdrop(item.playerinfo.playerno)"
                >
                  {{ $t("button.common.delete") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-lg-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.playerinfo.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.nickname") }}
                    </div>
                    <div class="col-8 py-0">
                      <MemberInfo
                        :nickname="item.playerinfo.nickname"
                        :playerno="item.playerinfo.playerno"
                        :displayText="item.playerinfo.nickname"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.email") }}</div>
                    <div class="col-8 text-break">
                      {{ item.playerinfo.email }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.gender") }}</div>
                    <div class="col-8">
                      {{
                        item.playerinfo.gender === "M"
                          ? $t("filter.common.male")
                          : $t("filter.common.female")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.favorite_location") }}
                    </div>
                    <div class="col-8 shop-name">
                      <p
                        v-for="(shop, index_s) in item.shoplist"
                        :key="index_s + 's'"
                      >
                        {{ shop.shopname }}
                      </p>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">
              {{ $t("text.tournament.select_invite") }}
            </td>
          </tr>
        </tbody>
      </table>
      <!-- <b-pagination-nav
        :link-gen="linkGen2"
        :number-of-pages="member_page_total"
        v-model="searchData2.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="member_page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="3"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav> -->

      <h6 class="modal-subtitle mt-5">
        {{ $t("text.common.member_list") }}
      </h6>
      <b-form @submit="onModalSubmit2" class="filter-group row g-2">
        <div class="col-12 col-md-auto">
          <select class="form-select-lg" v-model="searchData2.searchtype">
            <option value="P.nickname">
              {{ $t("filter.common.nickname") }}
            </option>
            <option value="P.email">
              {{ $t("filter.common.email") }}
            </option>
          </select>
        </div>

        <div class="col-12 col-md-auto">
          <div class="input-group">
            <input
              type="text"
              class="form-control form-control-lg"
              v-model="searchData2.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>

      <table class="table board table-sm border-1">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell w-1">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto">{{ $t("title.common.id") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.email") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.gender") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.favorite_location") }}
            </th>
            <th class="col-auto w-1">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="member_total_cnt">
          <template v-for="(item, index) in member_items">
            <tr :key="index + 'l2'">
              <td class="col-auto d-none d-lg-table-cell w-1">
                {{ item.playerinfo.no }}
              </td>
              <td class="col-auto text-start text-lg-center">
                {{ item.playerinfo.id }}
              </td>
              <td class="col-auto d-none d-lg-table-cell text-start">
                <MemberInfo
                  :nickname="item.playerinfo.nickname"
                  :playerno="item.playerinfo.playerno"
                  :displayText="item.playerinfo.nickname"
                />
              </td>
              <td class="col-auto d-none d-lg-table-cell text-break text-start">
                {{ item.playerinfo.email }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                {{
                  item.playerinfo.gender === "M"
                    ? $t("filter.common.male")
                    : $t("filter.common.female")
                }}
              </td>
              <td class="col-auto d-none d-lg-table-cell shop-name">
                <p
                  v-for="(shop, index_s) in item.shoplist"
                  :key="index_s + 's'"
                >
                  {{ shop.shopname }}
                </p>
              </td>
              <td class="col-auto w-1">
                <button
                  type="button"
                  class="btn btn-xs"
                  :class="
                    tour_member_items.some(
                      (v) => v.playerinfo.playerno === item.playerinfo.playerno
                    )
                      ? 'btn-primary'
                      : 'btn-outline-secondary'
                  "
                  @click="admintournamentplayerapply(item.playerinfo.playerno)"
                >
                  {{ $t("button.common.apply") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr2(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide2 === index }"
                />
              </td>
            </tr>
            <tr
              class="d-lg-none"
              :class="{ show: view_hide2 === index }"
              :key="index + 'r2'"
              v-if="view_hide2 === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.playerinfo.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.nickname") }}
                    </div>
                    <div class="col-8 py-0">
                      <MemberInfo
                        :nickname="item.playerinfo.nickname"
                        :playerno="item.playerinfo.playerno"
                        :displayText="item.playerinfo.nickname"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.email") }}</div>
                    <div class="col-8 text-break">
                      {{ item.playerinfo.email }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.gender") }}</div>
                    <div class="col-8">
                      {{
                        item.playerinfo.gender === "M"
                          ? $t("filter.common.male")
                          : $t("filter.common.female")
                      }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.favorite_location") }}
                    </div>
                    <div class="col-8 shop-name">
                      <p
                        v-for="(shop, index_s) in item.shoplist"
                        :key="index_s + 'm'"
                      >
                        {{ shop.shopname }}
                      </p>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen2"
        :number-of-pages="member_page_total"
        v-model="searchData2.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="member_page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="3"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>

      <template #modal-footer="{}">
        <b-button
          size="md"
          variant="primary"
          :aria-label="
            $t('text.common.invitation_list') +
            ' ' +
            $t('button.membership.excel_download')
          "
          @click="excelSave"
        >
          {{
            $t("text.common.invitation_list") +
            " " +
            $t("button.membership.excel_download")
          }}
        </b-button>
        <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.close')"
          @click="$bvModal.hide('modal-tournament-invitational')"
        >
          {{ $t("button.common.close") }}
        </b-button>
        <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.save')"
          @click="admintournamentplayersave()"
        >
          {{ $t("button.common.apply") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import commonDatePicker from "@/components/common/datepicker/Picker";
import "@/filter/common";
import ax from "@/api/tournament";
import _ from "lodash";
export default {
  name: "TournamentWrite",
  data() {
    return {
      tournamentno: this.$route.params.tournamentno || 0,
      tournamentno_temp: this.$dayjs().unix(),
      tournamentshoplist: [],
      tournamentshoplist2: [],
      form: {
        shopno: 0,
        shopname: "",
        title: "",
        startdate: "",
        enddate: "",
        remark: "",
        etcprize: "",
        rankno: 1,
        rankprizelist: [],
        regtype: 4,
        gametype_fk: 1,
        entrylimit: 0,
        tourtype_fk: 1,
        wind: 1,
        mulligan: 2,
        teeboxman: 2,
        teeboxwoman: 3,
        // playhandicap5: 0,
        // playhandicap10: 0,
        // playhandicap15: 0,
        // playhandicap20: 0,
        // playhandicap25: 0,
        // playhandicap30: 0,
        // playhandicap35: 0,
        // playhandicap40: 0,
        // playhandicap45: 0,
        // playhandicap50: 0,
        courselistcnt: 0,
        courselist: [],
        subcourselistcnt: 0,
        subcourselist: [],
        subcoursetype: [0, 0],
        subcourseselectlistcnt: 0,
        subcourseselectlist: [],
        // subcourseselecttype: [],
        shoplistcnt: 0,
        shoplist: [],
        status: "1",
        level: 1,
        greenspeed_fk: 3,
        greengravity_fk: 3,
        tour_class: 1,
        tour_rank_type: 0,
        participationtype_fk:1,
        oom_point: false,
        display_flag: false,
        product_id: "",
      },
      defaultItems: {
        times: [
          "00:00",
          "01:00",
          "02:00",
          "03:00",
          "04:00",
          "05:00",
          "06:00",
          "07:00",
          "08:00",
          "09:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
        ],
        room1: [],
        room2: [],
        room3: [],
        room4: [],
        room5: [],
      },
      items: {
        times: [
          "00:00",
          "01:00",
          "02:00",
          "03:00",
          "04:00",
          "05:00",
          "06:00",
          "07:00",
          "08:00",
          "09:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
        ],
        room1: [], // times idx와 동일하게 구성하고 booking list의 값을 넣어서 동작시킴
        room2: [],
        room3: [],
        room4: [],
        room5: [],
      },
      option: {
        starttimes: [
          "00:00",
          "01:00",
          "02:00",
          "03:00",
          "04:00",
          "05:00",
          "06:00",
          "07:00",
          "08:00",
          "09:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
          "16:00",
          "17:00",
          "18:00",
          "19:00",
          "20:00",
          "21:00",
          "22:00",
          "23:00",
        ],
        endtimes: [
          "00:59",
          "01:59",
          "02:59",
          "03:59",
          "04:59",
          "05:59",
          "06:59",
          "07:59",
          "08:59",
          "09:59",
          "10:59",
          "11:59",
          "12:59",
          "13:59",
          "14:59",
          "15:59",
          "16:59",
          "17:59",
          "18:59",
          "19:59",
          "20:59",
          "21:59",
          "22:59",
          "23:59",
        ],
      },
      location: {},
      tournamentcourselist: [],
      tournamentcoursenamelist: [],
      rank_count: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38,
        39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
      ],
      shoplistcnt: 0,
      shoplist: [],
      searchData: {
        searchtype: this.$store.state.searchData.searchtype || 1,
        searchname: this.$store.state.searchData.searchname || "",
        pageno: this.$store.state.searchData.pageno || 1,
      },
      searchData2: {
        searchtype: "P.nickname",
        searchname: "",
        pageno: 1,
      },
      searchData3: {
        pageno: 1,
      },
      page_total: 1,
      total_cnt: 0,
      shop_cnt: 0,
      member_page_total: 1,
      member_total_cnt: 0,
      member_items: [],
      tour_member_page_total: 1,
      tour_member_total_cnt: 0,
      tour_member_items: [],
      data_yn: true,
      data_yn2: true,

      rows: 10,
      rows2: 5,
      rows3: 5,
      items: [],
      tournamentlocation: [],
      view_hide: null,
      view_hide2: null,
      view_hide3: null,
      modal_status: false,
      courseview_yn: "n",
      starttime: this.$dayjs(new Date()).format("00:00"),
      endtime: this.$dayjs(new Date()).format("23:59"),
      file: [],
      tourbinary: [],
    };
  },
  methods: {
    excelSave() {
      ax.excelSave(this.tournamentno, this.searchData3, (body) => {
        let tab_text =
          '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
        tab_text +=
          '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
        tab_text +=
          "<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
        tab_text += "<x:Name>Invitation List</x:Name>";
        tab_text +=
          "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
        tab_text += "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
        tab_text += "<table>";
        tab_text += body;
        tab_text += "</table></body></html>";

        var today = new Date();

        var year = today.getFullYear();
        var month = ("0" + (today.getMonth() + 1)).slice(-2);
        var day = ("0" + today.getDate()).slice(-2);

        var dateString = year + "-" + month + "-" + day;

        const fileName = "invitation".concat("_", dateString, ".xls");
        // const fileName = filename;
        const a_tag = document.createElement("a");
        const blob = new Blob([tab_text], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });
        a_tag.href = window.URL.createObjectURL(blob);
        a_tag.download = fileName;
        a_tag.click();
      });
    },
    fileSelect(e, idx) {
      // console.log("e", idx);
      // alert(e.dataTransfer.files[0]);

      if (this.tourbinary[idx] && this.tourbinary[idx].binary_pk) {
        let binary_pk = this.tourbinary[idx].binary_pk;
        if (e.dataTransfer) {
          this.form["updatefilename[" + binary_pk + "]"] =
            e.dataTransfer.files[0];
        } else {
          this.form["updatefilename[" + binary_pk + "]"] = e.target.files[0];
        }
      } else {
        if (e.dataTransfer) {
          this.form["filename[" + idx + "]"] = e.dataTransfer.files[0];
        } else {
          this.form["filename[" + idx + "]"] = e.target.files[0];
        }
      }
    },
    onSubmit(event) {
      event.preventDefault();
      if (this.form.title === "") {
        alert(this.$i18n.t("alert.tournament.competition_title"));
        return false;
      }
      if (this.form.startdate === "") {
        alert(this.$i18n.t("alert.tournament.startdate_competition"));
        return false;
      }
      if (this.form.enddate === "") {
        alert(this.$i18n.t("alert.tournament.enddate_competition"));
        return false;
      }
      if (this.form.remark === "") {
        alert(this.$i18n.t("alert.tournament.competition_information"));
        return false;
      }
      if (this.form.etcprize === "") {
        alert(this.$i18n.t("alert.tournament.other_presentation"));
        return false;
      }

      if (!this.file[0] && !this.tournamentno) {
        alert(
          this.$i18n.t("alert.common.field_required", {
            field: this.$i18n.t("text.common.tournament_banner") + " 1",
          })
        );
        return false;
      }

      for (let i = 0; i < this.form.rankno; i++) {
        if (
          this.form.rankprizelist.rankprize[i] === "" ||
          !this.form.rankprizelist.rankprize[i]
        ) {
          alert(
            this.$i18n.t("alert.common.field_enter", {
              field: this.$i18n.t("title.tournament.prize_goods"),
            })
          );
          // alert(this.$i18n.t("alert.tournament.award_point"));
          return false;
        }
      }

      if (this.form.courselistcnt < 1) {
        alert(this.$i18n.t("alert.tournament.select_course"));
        return false;
      }

      if (
        (this.form.subcoursetype[0] === "0" || !this.form.subcoursetype[0]) &&
        (this.form.subcoursetype[1] === "0" || !this.form.subcoursetype[1])
      ) {
        alert(this.$i18n.t("alert.tournament.select_subcourse"));
        return false;
      }
      this.form.startdate = this.form.startdate + " " + this.starttime + ":00";
      this.form.enddate = this.form.enddate + " " + this.endtime + ":59";

      if (this.tournamentno === 0) {
        // 등록
        ax.set_admintournamentwrite(this.form, (flag, data) => {
          // console.log(flag, data);
          alert(data.message);
          if (flag) {
            this.$router.push({ name: "TournamentList" });
          } else {
            return false;
          }
        });
      } else {
        // 수정
        this.form.shoplistcnt = this.tournamentshoplist.length;
        ax.set_ownertournamentedit(
          this.form,
          this.tournamentno,
          (flag, data) => {
            // console.log(flag, data);
            alert(data.message);
            if (flag) {
              this.$router.push({ name: "TournamentList" });
              // location.reload()
            } else {
              return false;
            }
          }
        );
      }
    },
    startDateChange(v) {
      this.form.startdate = v;
    },
    endDateChange(v) {
      this.form.enddate = v;
    },
    get_admintournamentview() {
      ax.get_admintournamentview(this.tournamentno, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.form.subcourseselectlist = data.subcourseselectlist;
          this.form.subcourseselectlistcnt = data.subcourseselectlistcnt;

          // data.subcourseselectlist.forEach((v, i) => {
          //   this.form.subcoursetype[v.subcourseselectseq - 1] =
          //     v.subcourseselectseq;
          // });

          this.tournamentshoplist = data.tournamentshoplist;
          for (let i = 0; i < this.tournamentshoplist.length; i++) {
            this.form.shopno = this.tournamentshoplist[i].shopno;
            this.form.shopname = this.tournamentshoplist[i].shopname;
          }
          this.form.title = data.tournamentinfo.title;
          this.form.remark = data.tournamentinfo.remark;
          this.form.startdate = this.$dayjs(
            data.tournamentinfo.timezone_startdate
          ).format("YYYY-MM-DD");
          this.form.enddate = this.$dayjs(
            data.tournamentinfo.timezone_enddate
          ).format("YYYY-MM-DD");

          this.starttime = this.$dayjs(
            data.tournamentinfo.timezone_startdate
          ).format("HH:00");
          this.endtime = this.$dayjs(
            data.tournamentinfo.timezone_enddate
          ).format("HH:59");

          // if (
          //   this.$dayjs(data.tournamentinfo.timezone_enddate).format(
          //     "HH:mm:ss"
          //   ) == "23:59:59"
          // )
          //   this.endtime = "24:00";

          this.form.regtype = data.tournamentinfo.regtype;
          this.form.gametype_fk = data.tournamentinfo.gametype_fk;
          this.form.entrylimit = data.tournamentinfo.entrylimit;
          this.form.tourtype_fk = data.tournamentinfo.tourtype_fk;
          this.form.tour_class = data.tournamentinfo.tour_class;
          this.form.tour_rank_type = data.tournamentinfo.tour_rank_type;
          this.form.participationtype_fk = data.tournamentinfo.participationtype_fk;
          this.form.oom_point =
            data.tournamentinfo.oom_point > 0 ? true : false;
          this.form.display_flag =
            data.tournamentinfo.display_flag > 0 ? true : false;
          this.form.etcprize = data.tournamentprizeetc.etcprize;
          this.form.rankno = data.tournamentprizerank.length;
          for (let i = 0; i < data.tournamentprizerank.length; i++) {
            this.form.rankprizelist.rankprize[i] =
              data.tournamentprizerank[i].rankprize;
          }
          this.form.wind = data.tournamentdetail.wind;
          this.form.mulligan = data.tournamentdetail.mulligan;
          this.form.teeboxman = data.tournamentdetail.teeboxman;
          this.form.teeboxwoman = data.tournamentdetail.teeboxwoman;
          // this.form.playhandicap5 = data.tournamentdetail.playhandicap5;
          // this.form.playhandicap10 = data.tournamentdetail.playhandicap10;
          // this.form.playhandicap15 = data.tournamentdetail.playhandicap15;
          // this.form.playhandicap20 = data.tournamentdetail.playhandicap20;
          // this.form.playhandicap25 = data.tournamentdetail.playhandicap25;
          // this.form.playhandicap30 = data.tournamentdetail.playhandicap30;
          // this.form.playhandicap35 = data.tournamentdetail.playhandicap35;
          // this.form.playhandicap40 = data.tournamentdetail.playhandicap40;
          // this.form.playhandicap45 = data.tournamentdetail.playhandicap45;
          // this.form.playhandicap50 = data.tournamentdetail.playhandicap50;
          this.form.courselistcnt = data.tournamentcoursecnt;
          this.form.courselist = [];
          for (let j = 0; j < data.tournamentcourse.length; j++) {
            this.form.courselist[j] = data.tournamentcourse[j].courseno;
            this.get_admintournamentsubcourselist(this.form.courselist[j]);
          }

          this.courseview_yn = "y";
          this.form.status = data.tournamentinfo.status;
          this.form.product_id = data.tournamentinfo.product_id;
          this.form.level = data.tournamentinfo.level;
          this.form.greenspeed_fk = data.tournamentinfo.greenspeed_fk;
          this.form.greengravity_fk = data.tournamentinfo.greengravity_fk;
          this.tourbinary = data.tourbinary;
        } else {
          alert(data);
        }
      });
    },
    get_admintournamentcourselist() {
      ax.get_admintournamentcourselist(this.tournamentno, (flag, data) => {
        if (flag) {
          this.tournamentcourselist = data.courselist;
          for (let i = 0; i < data.courselist.length; i++) {
            this.tournamentcoursenamelist[data.courselist[i].maincourseno] =
              data.courselist[i].coursename;
          }
        } else {
          alert(data.message);
        }
      });
    },
    chk_mc() {
      // console.log("this.form.courselist", this.form.courselist);
      if (this.form.courselist.length > 1) {
        // alert(this.$i18n.t("text.common.only_one_golfcourse"));
        this.form.courselist.shift();
        // console.log("this.form.courselist", this.form.courselist);
      }
      this.form.courselistcnt = this.form.courselist.length;

      if (this.form.courselistcnt > 0) {
        this.get_admintournamentsubcourselist(this.form.courselist);
        this.courseview_yn = "y";
      } else {
        this.courseview_yn = "n";
      }
    },
    get_admintournamentsubcourselist(courseno) {
      ax.get_admintournamentsubcourselist(courseno, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          this.form.subcourselist = data.subcourselist;
          this.form.subcourselistcnt = data.subcourselist.length;

          this.form.subcourselist.forEach((v, i) => {
            this.form.subcourseselectlist.forEach((v_, i_) => {
              if (v.subcourseno == v_.subcourseselectno) {
                this.form.subcoursetype[v.subcourseseq - 1] =
                  v_.subcourseselectseq;
              }
            });
          });
          // console.log(
          //   "this.form.subcourseselectlist",
          //   this.form.subcourseselectlist
          // );
          // for (let i = 0; i < this.form.subcourselist.length; i++) {
          //   if (
          //     this.form.subcourseselectlistcnt > 0 &&
          //     this.form.subcourseselectlist[i]
          //   ) {
          //     // alert(this.form.subcourseselectlist[i].subcourseselectseq);
          //     this.form.subcoursetype[i] =
          //       this.form.subcourseselectlist[i].subcourseselectseq;
          //   } else {
          //     // this.form.subcoursetype[i] = data.subcourselist[i].subcourseseq;
          //   }
          // }
        } else {
          alert(data);
        }
      });
    },
    input_rankno() {},
    change_gametype() {
      if (this.form.gametype_fk==1) {
        this.form.tourtype_fk = 1;
        this.form.tour_rank_type= 0;
      } else {
        this.form.tourtype_fk = 1;
        this.form.tour_rank_type= 1;
      }

    },
    // change_participation_type() {
    //   if (this.form.participationtype_fk==1) {
    //       this.form.product_id= 0;
    //   }
    // },


    get_admintournamentshoplist2() {
      ax.get_admintournamentshoplist2((flag, data) => {
        if (flag) {
          this.tournamentshoplist2 = data.tournamentshoplist2;
        } else {
          alert(data);
        }
      });
    },
    shop_select() {
      this.form.shopno = "";
      this.form.shopname = "";
      this.form.shopno = this.location.shopno;
      this.form.shopname = this.location.shopname;
    },
    show_modal() {
      this.searchData.pageno = 1;
      this.searchData.searchname = "";
      this.searchData.searchtype = "1";
      this.$router.push({
        query: {
          searchname: "",
          searchtype: "1",
        },
      });
      this.modal_status = true;
      this.$bvModal.show("modal-add-shop");
    },
    close_modal() {
      this.modal_status = false;
      this.$router.push({ query: {} });
      this.$bvModal.hide("modal-add-shop");
    },
    invitational_modal() {
      this.searchData2.pageno = 1;
      this.get_tourplayerlist();
      this.get_playerlist();
      this.$bvModal.show("modal-tournament-invitational");
    },
    get_playerlist() {
      ax.get_playerlist(this.searchData2, (flag, data) => {
        if (flag) {
          this.member_total_cnt = data.playerlistcnt;
          this.member_page_total = Math.ceil(data.playerlistcnt / this.rows2);
          this.member_items = data.playerlist;
        } else {
          this.member_page_total = 0;
          this.member_items = [];
          alert(data.message);
        }
      });
    },
    get_tourplayerlist() {
      ax.get_tourplayerlist(
        this.tournamentno,
        this.searchData3,
        (flag, data) => {
          if (flag) {
            this.tour_member_total_cnt = data.tourplayerlistcnt;
            this.tour_member_page_total = Math.ceil(
              data.tourplayerlistcnt / this.rows3
            );
            this.tour_member_items = data.tourplayerlist;
          } else {
            this.member_page_total = 0;
            this.tour_member_items = [];
            alert(data.message);
          }
        }
      );
    },
    get_admintournamentshoplist() {
      ax.get_admintournamentshoplist(
        this.tournamentno,
        this.searchData,
        (flag, data) => {
          if (flag) {
            if (data.shoplistcnt <= 0) {
              this.data_yn2 = false;
              return false;
            } else {
              this.data_yn2 = true;
            }
            this.total_cnt = data.shoplistcnt;
            this.page_total = Math.ceil(data.shoplistcnt / this.rows);
            this.items = data.shoplist;
            this.shop_cnt = data.tournamentshoplistcnt;
            if (data.tournamentshoplistcnt <= 0) {
              this.data_yn = false;
              return false;
            } else {
              this.data_yn = true;
            }
            this.tournamentlocation = data.tournamentshoplist;
          } else {
            this.data_yn = false;
            this.data_yn2 = false;
            this.page_total = 0;
            alert(data);
          }
        }
      );
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
    toggle_tr2(index) {
      if (this.view_hide2 === index) this.view_hide2 = null;
      else this.view_hide2 = index;
    },
    toggle_tr3(index) {
      if (this.view_hide3 === index) this.view_hide3 = null;
      else this.view_hide3 = index;
    },
    onModalSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$router.push({
        query: {
          searchname: this.searchData.searchname,
          searchtype: this.searchData.searchtype,
        },
      });
    },
    onModalSubmit2(event) {
      event.preventDefault();
      this.searchData2.pageno = 1;
      this.get_playerlist();
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
      // return pageNum === 1
      //   ? `?searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      //   : `?page=${pageNum}&searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`;
    },
    linkGen2(pageNum) {
      return `?page=${pageNum}`;
      // return pageNum === 1
      //   ? `?searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      //   : `?page=${pageNum}&searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`;
    },
    linkGen3(pageNum) {
      return `?page3=${pageNum}&page=${this.searchData2.pageno}`;
      // return pageNum === 1
      //   ? `?searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      //   : `?page=${pageNum}&searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`;
    },
    admintournamentplayerapply(playerno) {
      if (
        this.tour_member_items.some((v) => v.playerinfo.playerno === playerno)
      ) {
        alert(this.$i18n.t("alert.tournament.already_applied"));
        return false;
      }
      this.tour_member_items = [
        ...this.tour_member_items,
        this.member_items.find((v) => v.playerinfo.playerno === playerno),
      ];
    },
    admintournamentplayerdrop(playerno) {
      this.tour_member_items = this.tour_member_items.filter(
        (v) => v.playerinfo.playerno !== playerno
      );
    },
    admintournamentplayersave() {
      // if (this.shop_cnt < 1) {
      // alert(this.shop_cnt);
      ax.set_admintournamentplayersave(
        this.tournamentno,
        { player_pk: this.tour_member_items.map((v) => v.playerinfo.playerno) },
        (flag, data) => {
          alert(data.message);
          // this.$bvModal.hide('modal-tournament-invitational');
          if (flag) {
            this.get_tourplayerlist();
          } else {
            return false;
          }
        }
      );
      // } else {
      //   alert("하나만 선택할 수 있습니다.");
      //   return false;
      // }
    },
    admintournamentshopapply(shopno, shopname) {
      // if (this.shop_cnt < 1) {
      // alert(this.shop_cnt);
      ax.set_admintournamentshopapply(
        this.tournamentno,
        shopno,
        (flag, data) => {
          if (flag) {
            this.form.shopno = shopno;
            this.form.shopname = shopname;
            this.tournamentshoplist = [
              {
                shopno: shopno,
                shopname: shopname,
              },
            ];
            this.get_admintournamentshoplist();
          } else {
            this.$notify({
              group: "alert",
              type: "warn",
              title: "Notice",
              text: data,
            });
            return false;
          }
        }
      );
      // } else {
      //   alert("하나만 선택할 수 있습니다.");
      //   return false;
      // }
    },
    admintournamentshopdrop(shopno) {
      let idx = this.form.shopno.indexOf(shopno);
      if (this.shop_cnt < 1) {
        // alert(this.shop_cnt);
        ax.set_admintournamentshopdrop(
          this.tournamentno,
          shopno,
          (flag, data) => {
            if (flag) {
              this.tournamentshoplist.splice(idx, 1);
              this.form.shopno.splice(idx, 1);
              this.form.shopname.splice(idx, 1);
              this.get_admintournamentshoplist();
            } else {
              this.$notify({
                group: "alert",
                type: "warn",
                title: "Notice",
                text: data,
              });
              return false;
            }
          }
        );
      } else {
        alert(this.$i18n.t("text.common.no_items_selected"));
        return false;
      }
    },
  },
  watch: {
    "$route.query.page": function () {
      this.searchData2.pageno = parseInt(this.$route.query.page) || 1;
      this.get_playerlist();
    },
    "$route.query.page3": function () {
      this.searchData3.pageno = parseInt(this.$route.query.page3) || 1;
      this.get_tourplayerlist();
    },

    "searchData2.searchtype": function () {
      this.searchData2.pageno = 1;
      this.get_playerlist();
    },
    "searchData2.searchname": function () {
      this.searchData2.pageno = 1;
      this.get_playerlist();
    },

    searchData: {
      handler: function (val, oldVal) {
        this.$store.commit("setSearchData", val);
      },
      deep: true,
    },
  },
  created() {
    // 코스불러오기
    this.get_admintournamentcourselist();
    this.form.rankno = 1;
    this.form.rankprizelist.rankprize = [];
    if (this.tournamentno !== 0) {
      // 대회보기
      this.get_admintournamentview();
    } else {
      // 등록 매장불러오기
      this.get_admintournamentshoplist2();
    }
  },
};
</script>
